import useGetPodcastEpisodeDetail from 'api/hooks/useGetPodcastEpisodeDetail';
import Chip from 'components/Chip';
import Spacer from 'components/Spacer';
import Thumbnail from 'components/Thumbnail';
import { Heading } from 'components/Typography';
import { useModalContents } from 'context/ModalContentsContext';
import { ContinueListeningModal } from 'context/ModalContext';
import { useExperiment } from 'experiments';
import styles from './ContinueListeningContents.module.scss';

interface ContinueListeningContentsProps {}

const ContinueListeningContents: React.FC<
  ContinueListeningContentsProps
> = () => {
  const { params, onRequestClose } =
    useModalContents<ContinueListeningModal['params']>();

  const { podcastId, episodeId } = params;

  const { data } = useGetPodcastEpisodeDetail({ episodeId, podcastId });
  const experiment41 = useExperiment('Experiment0041');

  const headline =
    experiment41?.variantName === 'A'
      ? 'Pick up where you left off:'
      : data?.title;
  const CTA =
    experiment41?.variantName === 'A'
      ? 'CONTINUE LISTENING'
      : 'PLAY PODCAST EPISODE';

  return (
    <Spacer
      align="center"
      className={styles.root}
      orientation="vertical"
      space={3}
    >
      <Thumbnail
        alt="episode artwork"
        size="large"
        src={data?.thumbnailImageUrl}
      />
      <Heading className={styles.headline} align="center" level={1}>
        {headline}
      </Heading>
      <Chip onClick={onRequestClose} className={styles.cta}>
        {CTA}
      </Chip>
    </Spacer>
  );
};

export default ContinueListeningContents;
